export const SOS_DEMO_USER_ID = 78;
export const DEMO_EMPRESA_NOMBRE = "S.O.S Contingencias";

const MASK_STRING_KEYS = new Set(["razon_social", "nombre_comercial"]);

export function isDemoUser(user) {
  return user && user.id === SOS_DEMO_USER_ID;
}

export function maskDemoValue(value, user) {
  if (!isDemoUser(user) || value === null || value === undefined || value === "") {
    return value;
  }
  return DEMO_EMPRESA_NOMBRE;
}

export function maskDemoData(data, user) {
  if (!isDemoUser(user) || data === null || data === undefined) {
    return data;
  }
  maskObject(data);
  return data;
}

function maskObject(obj) {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    obj.forEach((item) => maskObject(item));
    return obj;
  }

  if (typeof obj !== "object") {
    return obj;
  }

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (typeof value === "string" && value) {
      if (MASK_STRING_KEYS.has(key)) {
        obj[key] = DEMO_EMPRESA_NOMBRE;
        return;
      }
      if (key === "cliente") {
        obj[key] = DEMO_EMPRESA_NOMBRE;
        return;
      }
    }

    if (value && typeof value === "object") {
      maskObject(value);
    }
  });

  return obj;
}
